import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IngSelect } from '../../inputs';

@Component({
  selector: 'ing-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() input: IngSelect;

  constructor() { }

  ngOnInit() {
    this.input.controlType = 'ing-select';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/select/select.component.ts